/* GENERATED FILE */
import { forwardRef } from "react";
import variants from "../defs/link-1-rec";
import IconBase from "../lib/icon-base";
import type { Icon } from "../lib/types";

const I: Icon = forwardRef((props, ref) => (
	<IconBase ref={ref} {...props} variants={variants} />
));

I.displayName = "Link1Rec";
export { I as Link1Rec };
